import React from "react";

const Spacer2 = ({ size }) => {
  return <div style={{ height: `${size || 70}px` }}></div>;
};

export default Spacer2;

//! Spacer in görevi Customer Service yazısı gibi section title için boşluk bırakır....
